import { inject, Injectable } from '@angular/core';
import { AvailableProfile, CurrentUser, CurrentUserContext, CurrentUserService } from '@rma/generic/ng/user';
import { nonNullable } from '@rma/generic/rxjs/operators/non-nullable';
import { cache } from 'decorator-cache-getter';
import { map, Observable } from 'rxjs';
import { LegacyUserService } from '../legacy/legacy-user.service';
import { UserContextService } from '../user-context/user-context.service';

/**
 * DashboardUserContextService
 *
 * Provides observable streams for the current dashboard user's context and related properties.
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardUserContextService {
  private readonly currentUserService = inject(CurrentUserService);
  private readonly userContextService = inject(UserContextService);
  //stop gap. Currently the only way to refresh the profile context is to refresh the current user.
  //Jamie has a new endpoint that will change this, but it is not yet implemented.
  private readonly legacyUserService = inject(LegacyUserService);

  /**
   * @deprecated use userContext$
   */
  @cache
  public get currentUser$(): Observable<CurrentUser | null> {
    return this.currentUserService.currentUser$;
  }

  @cache
  public get userContext$(): Observable<CurrentUserContext> {
    return this.userContextService.currentUserContext$.pipe(nonNullable());
  }

  @cache
  public get hasSeenWelcomeModal$(): Observable<boolean> {
    return this.userContext$.pipe(map((p) => p.hasSeenWelcomeModal));
  }

  @cache
  public get hasMultipleProfiles$(): Observable<boolean> {
    return this.userContext$.pipe(map((p) => p.hasMultipleProfiles));
  }

  @cache
  public get isImpersonating$(): Observable<boolean> {
    return this.userContext$.pipe(map((x) => x.isImpersonating));
  }

  @cache
  public get currentUserDefaultProfile$(): Observable<AvailableProfile> {
    return this.currentUserService.currentUserDefaultProfile$;
  }

  public refreshUserContext(): void {
    this.legacyUserService.refreshUserInfo();
  }
}
